export default "__VITE_ASSET__DnPdWQ0P__"